import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../services/authContext';
import { apiService } from '../services/apiService';
import { portalService } from '../services/portalService';

const MyGrades = () => {
  const { user } = useAuth();
  const [grades, setGrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadGrades = async () => {
      try {
        setLoading(true);
        setError('');
        const student = await portalService.getCurrentStudent(user.id);
        const gradeData = await apiService.get(`grades/student/${student._id}`);
        setGrades(gradeData || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load your grades.');
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      loadGrades();
    }
  }, [user]);

  const totalMarks = grades.reduce((sum, grade) => sum + Number(grade.marksObtained || 0), 0);
  const totalPossible = grades.reduce((sum, grade) => sum + Number(grade.totalMarks || 0), 0);
  const avg = totalPossible > 0 ? Math.round((totalMarks / totalPossible) * 100) : 0;

  if (loading) return <LoadingSpinner message="Loading your grades..." />;

  return (
    <div className="page-container">
      <div className="page-header"><h1>My Grades</h1></div>

      {error && <div className="error-message">{error}</div>}

      <div className="stats-grid" style={{ marginBottom: '2rem' }}>
        <div className="stat-card">
          <h3>Average Score</h3>
          <div className="stat-value" style={{ color: avg >= 50 ? '#388E3C' : '#D32F2F' }}>{avg}%</div>
        </div>
        <div className="stat-card">
          <h3>Assessments Graded</h3>
          <div className="stat-value">{grades.length}</div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="data-table">
          <thead>
            <tr><th>Assessment</th><th>Module</th><th>Marks</th><th>%</th><th>Remarks</th></tr>
          </thead>
          <tbody>
            {grades.length === 0 ? (
              <tr><td colSpan={5} className="no-data-message">No grades recorded yet.</td></tr>
            ) : grades.map(grade => (
              <tr key={grade._id}>
                <td>{grade.assessmentTitle}</td>
                <td>{grade.moduleName || grade.subjectName || 'Module'}</td>
                <td>{grade.marksObtained} / {grade.totalMarks}</td>
                <td>{grade.percentage ?? 0}%</td>
                <td>{grade.remarks || 'No remarks'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyGrades;
